"use client";

import { useMemo } from "react";
import { useSearchParams } from "next/navigation";
import { useTranslations } from "next-intl";
import { EventsLanding } from "@/components/events/EventsLanding";
import { parseFiltersFromQuery } from "@/utils/eventsFilters";

/**
 * Browser events browse shell that keeps filter query params shareable.
 */
export function EventsBrowseClient() {
  const t = useTranslations("events");
  const searchParams = useSearchParams();
  const filters = useMemo(
    () => parseFiltersFromQuery(new URLSearchParams(searchParams.toString())),
    [searchParams],
  );

  return (
    <div className="gruv-page gruv-page--events">
      <h1 className="gruv-page__title">{t("browse.title")}</h1>
      <p className="gruv-page__subtitle">{t("browse.subtitle")}</p>
      <EventsLanding filters={filters} />
    </div>
  );
}
